<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  filters: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style lang="less"></style>
